package com.eladfinish.bible.contest.common.usecases

import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.StringConstants.MAKAF
import com.eladfinish.bible.contest.extensions.replaceRegex

class RemoveTeamimAndMakafUseCase {

    operator fun invoke(pasuk: String): String =
        pasuk
            .replaceRegex(
                regex = StringConstants.Regex.TEAMIM_CHARS,
                replacement = ""
            )
            .replaceRegex(
                regex = MAKAF.toString(),
                replacement = " "
            )
            .replaceRegex(
                regex = "${StringConstants.SPACE_OR_NO_BREAK_SPACE}+",
                replacement = " "
            ).trim()

}
